export default "__VITE_ASSET__CcyptDgu__"